import { baseThemeValues } from 'constants/common';

const labelBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: 14,
  fontWeight: 500,
};

const thumbBase = {
  borderColor: 'palette.transparent',
  borderRadius: '36px',
  borderWidth: '0px',
  boxShadow: 'palette.black:0.1',
};

export const switchTheme = {
  checked: {
    base: {
      icon: 'palette.primary.20',
      label: {
        ...labelBase,
        text: 'palette.tertiary.95',
      },
      thumb: {
        ...thumbBase,
        bg: 'palette.primary.99',
      },
      track: {
        bg: 'palette.primary.20',
        borderColor: 'palette.primary.20',
        borderRadius: '12px',
        borderWidth: '1px',
        outlineColor: 'palette.transparent',
        outlineWidth: '0px',
      },
    },
    disabled: {
      icon: 'palette.neutral.40',
      label: {
        ...labelBase,
        text: 'palette.neutral.40',
      },
      thumb: {
        ...thumbBase,
        bg: 'palette.neutral.20',
      },
      track: {
        bg: 'palette.neutral.40',
        borderColor: 'palette.neutral.40',
        borderRadius: '12px',
        borderWidth: '1px',
        outlineColor: 'palette.transparent',
        outlineWidth: '0px',
      },
    },
    hover: {
      icon: 'palette.primary.10',
      label: {
        ...labelBase,
        text: 'palette.tertiary.95',
      },
      thumb: {
        ...thumbBase,
        bg: 'palette.primary.99',
      },
      track: {
        bg: 'palette.primary.10',
        borderColor: 'palette.transparent',
        borderRadius: '12px',
        borderWidth: '0px',
        outlineColor: 'palette.transparent',
        outlineWidth: '0px',
      },
    },
    pressed: {
      icon: 'palette.primary.20',
      label: {
        ...labelBase,
        text: 'palette.tertiary.95',
      },
      thumb: {
        ...thumbBase,
        bg: 'palette.primary.99',
      },
      track: {
        bg: 'palette.primary.20',
        borderColor: 'palette.primary.20',
        borderRadius: '12px',
        borderWidth: '1px',
        outlineColor: 'palette.primary.80',
        outlineWidth: '3px',
      },
    },
  },
  labelBase,
  notChecked: {
    base: {
      icon: 'palette.primary.20',
      label: {
        ...labelBase,
        text: 'palette.tertiary.95',
      },
      thumb: {
        ...thumbBase,
        bg: 'palette.primary.99',
      },
      track: {
        bg: 'palette.tertiary.20',
        borderColor: 'palette.tertiary.20',
        borderRadius: '12px',
        borderWidth: '1px',
        outlineColor: 'palette.transparent',
        outlineWidth: '0px',
      },
    },
    disabled: {
      icon: 'palette.neutral.40',
      label: {
        ...labelBase,
        text: 'palette.neutral.40',
      },
      thumb: {
        ...thumbBase,
        bg: 'palette.neutral.20',
      },
      track: {
        bg: 'palette.neutral.40',
        borderColor: 'palette.neutral.40',
        borderRadius: '12px',
        borderWidth: '1px',
        outlineColor: 'palette.transparent',
        outlineWidth: '0px',
      },
    },
    hover: {
      icon: 'palette.primary.10',
      label: {
        ...labelBase,
        text: 'palette.tertiary.95',
      },
      thumb: {
        ...thumbBase,
        bg: 'palette.primary.99',
      },
      track: {
        bg: 'palette.tertiary.30',
        borderColor: 'palette.tertiary.30',
        borderRadius: '12px',
        borderWidth: '1px',
        outlineColor: 'palette.transparent',
        outlineWidth: '0px',
      },
    },
    pressed: {
      icon: 'palette.primary.10',
      label: {
        ...labelBase,
        text: 'palette.tertiary.95',
      },
      thumb: {
        ...thumbBase,
        bg: 'palette.primary.99',
      },
      track: {
        bg: 'palette.primary.60',
        borderColor: 'palette.primary.60',
        borderRadius: '12px',
        borderWidth: '1px',
        outlineColor: 'palette.primary.80',
        outlineWidth: '3px',
      },
    },
  },
  thumbBase,
};
